import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ClubAvatar from '../../../Units/ClubAvatar';
import parameters from "../../../../config/parameters";
import { openDialog } from '../../../../store/actionCreators/dialog';
import {
  getCurrentClub,
  getClubChipBalance,
  getAccountAvatars,
  getRoleInCurrentClub
} from '../../../../store/selectors';
import '../../../../assets/stylesheets/ClubSlide/MainClub.scss'

const InfoRow = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id: clubId } = useParams();

  const clubInfo = useSelector(getCurrentClub);
  const clubChipBalance = useSelector(getClubChipBalance);
  const roleInClub = useSelector(getRoleInCurrentClub);

  const isAdminMember = [
    parameters.clubRoles.OWNER,
    parameters.clubRoles.MANAGER
  ].includes(roleInClub);
  
  const openExchange = useCallback(() => false, []);

  const openClubEdit = () => {
    if( isAdminMember ) {
      dispatch(openDialog('editClub', {club: clubInfo}));
    }
  };

  return (
    <React.Fragment>
      <div className="infoRow">
        <div className="editOpener" onClick={openClubEdit}>
          <ClubAvatar id={parseInt(clubId, 10)} withoutRole />
          <div className="clubInfo">
            <span>{clubInfo.clubName}</span>
            <p>{t('clubId')}: {clubInfo.clubId}</p>
          </div>
        </div>
        <div className="clubBalance" onClick={openExchange}>
          <span className="chipIcon"></span>
          <span className="balanceNumber">{clubChipBalance}</span>
          { isAdminMember && <button className="plus plusButton"></button> }
        </div>
      </div>
      <div className={`horizontalLine`} ></div>
    </React.Fragment>
  );
};

export default InfoRow;
